import { useNavigate } from 'react-router-dom'

export default function Send8822() {
  const navigate = useNavigate()

  return (
    <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-6 mt-4'>
      <p className='font-bold text-2xl text-[#646464]'>Print Form 8822</p>
      <p className='text-[#646464] text-lg text-left'>There's just <span className='font-bold'>one final step</span> to make sure everything with the IRS goes smoothly.</p>
      <p className='text-[#646464] text-lg text-left'>Please update your address with the IRS by printing, signing, and mailing <span className='font-bold'>Form 8822</span> now.</p>
      <button onClick={() => navigate('/8822')} className='px-6 py-3 bg-[#FF8C00] text-white font-semibold rounded-lg shadow hover:bg-[#e67600] transition'>
        Print Form 8822
      </button>
      <p className='text-sm text-gray-400 mt-2 text-center'>Thank you for your prompt attention.</p>
    </div>
  )
}